import { IconButton } from '@sparemin/blockhead';
import styled from 'styled-components';
import { EpisodeInputContainer } from '../styles';

export const Container = styled(EpisodeInputContainer)`
  height: auto;
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr minmax(0, 360px) 1fr;
  border-style: solid;
`;

export const Player = styled.iframe`
  width: 100%;
  aspect-ratio: 16 / 9;
  grid-column: 2;
  border: none;
  border-radius: 8px;
`;

export const SearchButton = styled(IconButton).attrs({
  variant: 'solid',
})`
  grid-column: 3;
  align-self: start;
  justify-self: end;
`;
